import Lockr from 'lockr'
import i18n from '@/utils/i18n'
//配置信息
import config from '@/config'

//cache
import cache from '@/utils/cache'

const app={
    state:{
        lang:(Lockr.get('mtrshops_lang')?cache.getCacheTemp(Lockr.get('mtrshops_lang')):'') || (config.Language?config.Language:cache.getCacheTemp(config.Language)),  //1. 英文，2.繁體，3.簡體
        UserToken:'',  //UserToken
        UserId:'',  //UserId
        UserAppCss:config.UserAppCss,  //主题色
        UserData:null,  //用户信息
        isCollapse:true,  //是否展示
        shopData:null,  //店铺信息
        fileData:null,  //文件信息
        FittingfileData:null,  //FittingOut文件信息
        UnReadMsgCount:0,  //消息數量
        tableSroll:0,
        preRouter:null,
        updateLunXun:false,
        logclient_pri:'',
        logserver_pri:'',
        basetableSroll:0,
        uploadDetail:null,  //Application of works – upload-History-Detail
        productPlay:true,
    },
    mutations:{
        //设置语种
        SET_LANG:(state,lang)=>{
            localStorage.setItem('dealLang',lang)
            state.lang=lang?lang:config.Language
            if(lang===null){
                Lockr.set('mtrshops_lang',cache.setCacheTemp(config.Language))
            }else{
                Lockr.set('mtrshops_lang',cache.setCacheTemp(lang))
            }

            if(i18n){
                i18n.locale=lang
            }
        },
        SET_Width:(state,flag)=>{
            
            state.productPlay=flag
            console.log("是否需要橫屏",state.productPlay)
        },
        SET_CLIENT_PRI:(state,key)=>{
            state.client_pri=key
            if(key===null){
                Lockr.rm('mtrshop_client_pri')
                Lockr.rm('mtrshop_client_pri_time')
            }else{
                Lockr.set('mtrshop_client_pri',key)
                Lockr.set('mtrshop_client_pri_time',(new Date).getTime())
            }
        },

        SET_SERVER_PRI:(state,key)=>{
            state.server_pri=key
            if(key===null){
                Lockr.rm('mtrshop_server_pri')
            }else{
                Lockr.set('mtrshop_server_pri',key)
            }
        },

        //设置是否展示
        SET_isCollapse:(state,isCollapse)=>{
            state.isCollapse=isCollapse?isCollapse:false
        },

        //设置updateLunXun
        SET_updateLunXun:(state,updateLunXun)=>{
            state.updateLunXun=updateLunXun?updateLunXun:false
        },

        //设置tableSroll
        SET_tableSroll:(state,tableSroll)=>{
            state.tableSroll=tableSroll?tableSroll:0
        },

        //设置basetableSroll
        SET_basetableSroll:(state,basetableSroll)=>{
            state.basetableSroll=basetableSroll?basetableSroll:0
        },

        //设置preRouter
        SET_preRouter:(state,preRouter)=>{
            state.preRouter=preRouter?preRouter:null
        },

        //设置UnReadMsgCount
        SET_UnReadMsgCount:(state,UnReadMsgCount)=>{
            state.UnReadMsgCount=UnReadMsgCount
            if(UnReadMsgCount===null){
                Lockr.rm('mtrshops_UnReadMsgCount')
            }else{
                Lockr.set('mtrshops_UnReadMsgCount',cache.setCacheTemp(UnReadMsgCount))
            }
        },

        //设置UserToken
        SET_UserToken:(state,UserToken)=>{
            state.UserToken=UserToken
            if(UserToken===null){
                Lockr.rm('mtrshops_UserToken')
            }else{
                Lockr.set('mtrshops_UserToken',cache.setCacheTemp(UserToken))
            }
        },

        //设置UserId
        SET_UserId:(state,UserId)=>{
            state.UserId=UserId
            if(UserId===null){
                Lockr.rm('mtrshops_UserId')
            }else{
                Lockr.set('mtrshops_UserId',cache.setCacheTemp(UserId))
            }
        },

        //设置颜色
        SET_UserAppCss:(state,UserAppCss)=>{
            state.UserAppCss=UserAppCss?UserAppCss:config.UserAppCss
            if(UserAppCss===null){
                Lockr.set('mtrshops_UserAppCss',cache.setCacheTemp(config.UserAppCss))
            }else{
                Lockr.set('mtrshops_UserAppCss',cache.setCacheTemp(UserAppCss))
            }
        },

        //用户信息
        SET_UserData:(state,UserData)=>{
            state.UserData=UserData?UserData:null
            if(UserData===null){
                Lockr.rm('mtrshops_UserData')
            }else{
                Lockr.set('mtrshops_UserData',UserData)
            }
        },

        //店铺
        SET_ShopData:(state,shopData)=>{
            state.shopData=shopData?shopData:null
        },

        //Application of works – upload-History-Detail
        SET_uploadDetail:(state,uploadDetail)=>{
            state.uploadDetail=uploadDetail?uploadDetail:null
            if(uploadDetail===null){
                Lockr.rm('mtrshops_uploadDetail')
            }else{
                Lockr.set('mtrshops_uploadDetail',uploadDetail)
            }
        },

        //FittingOut文件
        SET_fileData:(state,fileData)=>{
            state.fileData=fileData?fileData:null
            if(fileData===null){
                Lockr.rm('mtrshops_fileData')
            }else{
                Lockr.set('mtrshops_fileData',fileData)
            }
        },

        //文件
        SET_FittingfileData:(state,FittingfileData)=>{
            state.FittingfileData=FittingfileData?FittingfileData:null
            if(FittingfileData===null){
                Lockr.rm('mtrshops_FittingfileData')
            }else{
                Lockr.set('mtrshops_FittingfileData',FittingfileData)
            }
        },
    }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js